import moment from 'moment';

export default function configMoment() {
  require('../localization/moment');

  // extending moment.duration to support .format()
  const momentDurationFormatSetup = require('moment-duration-format');
  momentDurationFormatSetup(moment);
}
